<div id="attachments-preview">
  <div *ngFor="let attachment of attachments">
    <div class="attachment-wrapper" *ngIf="attachment">
      <div class="left cng-ico_agent_div" aria-hidden="true">
        <div class="rounded">
          <span class="cng-ico_agent"></span>
        </div>
      </div>

      <div class="chat-message-content clearfix">
        <div class="interlocutor-fullName">
          <span>{{ 'agent:contact.info.me' | translate }}</span>
          <time class="chat-time">{{ attachment.date | localizedDate: 'HH:mm' }}</time>
        </div>

        <div class="attachment">
          <div class="attachment-top">
            <div class="attachment-buttons">
              <button class="cng-ico_annuler" (click)="cancel(attachment)"></button>
              <button
                *ngIf="attachment.errorMessages && attachment.errorMessages.length > 0"
                class="cng-ico_reload"
                (click)="upload(attachment)"
              ></button>
            </div>
            <chat-attachment [filename]="attachment.file.name" [size]="attachment.file.size"></chat-attachment>
          </div>
          <div
            *ngIf="!(attachment.errorMessages && attachment.errorMessages.length > 0)"
            class="progress"
            [ngStyle]="{ width: attachment.progress + '%' }"
          ></div>
          <div *ngIf="attachment.errorMessages && attachment.errorMessages.length > 0" class="error-progress"></div>
        </div>
        <div *ngFor="let error of attachment.errorMessages" class="error-message" title="{{ error | translate }}">
          {{ error | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
